import { ADOnPremSensorController } from '../controller/ADOnPremSensorController';
import { SensorType } from '../../types/sensor-type';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { FormGroupValue } from '../../../../ui/gzForm/formGroup/types/form-group-value';
import { Observable } from 'rxjs';

export class ADOnPremSensorComponent extends BaseWebComponentElement {
  public controller!: ADOnPremSensorController;
  protected sensorType: SensorType;
  private sensorId: string;

  constructor() {
    super();
    this.sensorType = SensorType.AD_ONPREM_DOMAIN;
    this.initialSetup({
      controllerConstructor: ADOnPremSensorController,
    });
  }

  isEnabled(): boolean {
    return true;
  }

  public getIsConfigured(): boolean {
    return true;
  }

  public getSensorType(): SensorType {
    return this.sensorType;
  }

  public setEnabled(isEnabled: boolean): void {
    this.controller.view.setEnabledAllFields(isEnabled);
  }

  public setSensorId(id): void {
    this.sensorId = id;
  }

  public getSensorId(): string {
    return this.sensorId;
  }

  public getSensorName(): string {
    return this.controller.getSensorName();
  }

  public getValue(): FormGroupValue {
    return {};
  }

  public getSpecifics(): FormGroupValue {
    return this.controller.view.formGroup.getValueRecursively(this.controller.view.formGroup, true);
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.valid$;
  }

  public get valid(): boolean {
    return this.controller.view.validSubject.value;
  }

  public resetData(): void {
    return;
  }

  public setValues(values: FormGroupValue, force: boolean = false): void {
    return;
  }
}
